import React from 'react';
import { RouterContext } from '../../gs-component-right-rail';
import CancelConfirmation from '.';
import { RESPONSES_TAB } from '../RightRailContent/HeaderWithTabs';

interface SwitchTabConfirmationProps {
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onSwitch: () => void;
}

const SwitchTabConfirmation: React.FC<SwitchTabConfirmationProps> = ({ onSubmit, onSwitch }) => {
  const { push } = React.useContext(RouterContext);
  return (
    <CancelConfirmation
      onSubmit={(e): void => {
        onSubmit(e);
        push(RESPONSES_TAB);
      }}
      onClose={(): void => {
        onSwitch();
        push(RESPONSES_TAB);
      }}
      setShouldClose={(): void => {}}
    />
  );
};

export default SwitchTabConfirmation;
